<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-zoom-out-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 2c11.046 0 20 8.954 20 20 0 4.802-1.693 9.21-4.514 12.657l7.949 7.95a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-7.95-7.949A19.918 19.918 0 0122 42C10.954 42 2 33.046 2 22S10.954 2 22 2zm7 18a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h14z"/></svg>
</template>
<script>

export default {
  name: 'IconZoomOutFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
